import { IconProps } from "@tfg/ui"

export const IconWeaving = ({ size = 24, ...props }: IconProps) => (
  <svg
    id="weaving_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {
        ".weaving_svg__st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round}"
      }
    </style>
    <path
      className="weaving_svg__st0"
      d="M15.1 36.5V6.7M7.2 14.6H37M22.1 36.5V6.7M7.2 21.6H37M29.1 36.5V6.7M7.2 28.6H37"
    />
  </svg>
)
